import { motion } from "framer-motion";

const steps = [
  { n: "01", t: "Recherche & Analyse", d: "Nous analysons vos besoins et recherchons les fournisseurs les plus adaptés en Chine et en Corée." },
  { n: "02", t: "Vérification Qualité", d: "Inspection complète des installations, des certifications et des échantillons de produits." },
  { n: "03", t: "Négociation & Logistique", d: "Nous négocions les meilleurs prix et gérons tout le transport et les formalités douanières." },
  { n: "04", t: "Suivi & Support", d: "Suivi continu, support client et assistance post-livraison garantis." },
];

export const Process = () => {
  return (
    <section id="process" className="relative bg-brand-navy py-24 lg:py-32 overflow-hidden">
      <div className="grain-overlay" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-brand-goldbright mb-4">Comment ça marche</p>
          <h2 className="font-display font-bold uppercase tracking-tight leading-none text-white text-4xl sm:text-5xl">
            Un processus simple en 4 étapes
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`process-step-${i}`}
              className="border-r border-b border-white/10 p-8 group hover:bg-white/5 transition-colors duration-300"
            >
              <p className="font-mono-accent text-brand-goldbright text-sm mb-6">{s.n}</p>
              <h3 className="font-display font-semibold text-xl text-white tracking-tight">{s.t}</h3>
              <p className="mt-3 text-sm text-white/60 leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
